var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSshKeysHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_1270)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_68_1270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3354 0.666687C8.46886 0.666687 5.33417 3.80138 5.33417 7.66794C5.33417 11.5345 8.46886 14.6692 12.3354 14.6692C16.202 14.6692 19.3367 11.5345 19.3367 7.66794C19.3367 3.80138 16.202 0.666687 12.3354 0.666687ZM14.6692 7.20119C13.6377 7.20119 12.8022 6.36571 12.8022 5.33419C12.8022 4.30267 13.6377 3.46719 14.6692 3.46719C15.7007 3.46719 16.5362 4.30267 16.5362 5.33419C16.5362 6.36571 15.7007 7.20119 14.6692 7.20119Z",
    fill: "url(#paint0_linear_68_1270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88212 10.3872L0.940172 15.3292C0.764674 15.5047 0.666656 15.7418 0.666656 15.9891V18.4032C0.666656 18.9185 1.08486 19.3367 1.60016 19.3367H4.01419C4.26157 19.3367 4.49961 19.2387 4.67417 19.0632L5.88119 17.8561C6.12857 17.6088 6.26766 17.2727 6.26766 16.9226C6.26766 16.1936 6.85856 15.6027 7.58763 15.6027C7.93769 15.6027 8.27375 15.4636 8.52113 15.2162L9.61612 14.1212C7.93582 13.4127 6.59065 12.0666 5.88212 10.3872Z",
    fill: "#BDCEEE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_1270",
    x1: 18.9633,
    y1: 14.4825,
    x2: 6.08096,
    y2: 1.04008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4671F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDCEEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_1270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_68_1270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSshKeysHover);
export default __webpack_public_path__ + "static/media/ssh-keys-hover.60d93fa27f3716c90dc07d08e0c83179.svg";
export { ForwardRef as ReactComponent };